<template>
  <div class="detailBox">
    <div
      style="position: absolute; z-index: 400; transform: translate(-52%, -130%)"
      :style="{
        left: form.x + 'px',
        top: form.y + 'px'
      }"
    >
      <div class="warn">
        <p style="color: #0ff; font-size: 15px">{{ form.param.name }}</p>
        <img
          class="close"
          @click="closeClick"
          src="~images/index/map/close.png"
        />
        <div class="flex contain">
          <div class="leftBar">
            <!-- <img style="width: 50px; height: 50px" src="~images/zhwl/img1.jpg" /> -->
          </div>
          <div class="rightBar" style="flex: 1">
            <div class="flex subCube">
              <div>
                <p class="num">{{ form.param.area }}</p>
                <span>土地面积（万亩）</span>
              </div>
              <div>
                <p class="num">{{ form.param.cl }}</p>
                <span>产量（吨）</span>
              </div>
            </div>
            <div class="flex subCube">
              <div>
                <p class="num">{{ form.param.cz }}</p>
                <span>产值（万元）</span>
              </div>
              <div>
                <p class="num">{{ form.param.lr }}</p>
                <span>利润（万元）</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    form: Object
  },
  methods: {
    closeClick() {
      this.$parent.poisiton = {};
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'
.detailBox
  z-index 10
  color #fff
.warn
  padding 5px 8px
  border-radius 5px
  background rgba(0,0,0,0.7)
  position relative
  // transform translate(-52%, -192%)
  z-index 400
  width 280px
  :before
    content ''
    transform translate(-35%,0)
    position absolute
    bottom -9px
    left 50%
    opacity 1
    border-top solid 10px rgba(51,51,51,0.7)
    border-right solid 10px transparent
    border-left solid 10px transparent
.close
  width 20px
  cursor pointer
  position absolute
  right 5px
  top 5px
.contain
  width 100%
  height 100px
.leftBar
  width 25%
.rightBar
  height 100%
.subCube
  height 50%
  justify-content space-between
.num
  font-size 20px
  text-align center
  color $textColor
</style>
